import React, { useState } from "react";
import { connect } from "react-redux";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./keycloak";

function Auth({ children, setUserToken, updateUserInfo, userToken }) {
  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: "login-required"
        // checkLoginIframe: false,
        // onLoad: "check-sso",
        // silentCheckSsoRedirectUri: window.location.origin + '/ silent-check-sso.html',
      }}
      onTokens={tokens => {
        // console.log("keycloak tokens ::::> ", tokens);
        setUserToken(tokens.token);
      }}
      children={children}
      onEvent={console.log}
    />

    // </ReactKeycloakProvider>
  );
}

export default connect(
  state => {
    return {
      userToken: state.userInfo?.userToken
    };
  },
  dispatch => {
    return {
      setUserToken: userToken =>
        dispatch({ type: "SET", key: "userToken", payload: userToken }),
      updateUserInfo: e => dispatch({ type: "UPDATE_USER_INFO", e })
    };
  }
)(Auth);
